import { withViewer } from '../../../external/common/hoc/with-viewer';
import AppRoot from '../../../external/my-posts-page/containers/app-root';

export default withViewer(AppRoot);
